import { render, staticRenderFns } from "./yazyjsxy.vue?vue&type=template&id=6c3b3616&scoped=true&"
import script from "./yazyjsxy.vue?vue&type=script&lang=js&"
export * from "./yazyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./yazyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./yazyjsxy.vue?vue&type=style&index=1&id=6c3b3616&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b3616",
  null
  
)

export default component.exports